import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {CardAttributeUpdateActionsEnum} from '../../../../helpers/models/cardAttributeUpdateHelpers';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {getAccounts} from '../../../../store/data/dataSelectors';
import {ContactDetailsUndoBannerState} from '../../../../store/panels/app/banners/bannersState';
import {
  ContactDetailsUndoBannerAction,
  undoContactDetailsBannerAction,
} from '../../../../store/panels/app/banners/contactDetailsUndoBannersActions';
import {AppPanelId} from '../../../../store/panels/panelStateBase';
import {ContactDetailsUndoBanner} from './contactDetailsUndoBanner';

/*
 * Props.
 */

interface ContactDetailsUndoBannerContainerProps {
  panelId: AppPanelId;
  state: ContactDetailsUndoBannerState;
}

/*
 * Selectors.
 */

function getAddedToAccountId(_state: AppState, props: ContactDetailsUndoBannerContainerProps) {
  const action = props.state.action as ContactDetailsUndoBannerAction;
  if (action.type !== CardAttributeUpdateActionsEnum.ADD_ACCOUNT) {
    return undefined;
  }
  return action.payload.newAttributeValue;
}

function makeGetAccount() {
  return createSelector([getAddedToAccountId, getAccounts], (accountId, accounts) => {
    if (!accountId) {
      return undefined;
    }
    return accounts[accountId];
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactDetailsUndoBannerContainerProps>()(() => ({
  account: makeGetAccount(),
}));

const mapDispatchToProps = makeMapDispatchToProps<ContactDetailsUndoBannerContainerProps>()(
  ({panelId, state}) => ({
    onUndoClick: () => undoContactDetailsBannerAction(panelId, state),
  }),
);

export const ContactDetailsUndoBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactDetailsUndoBanner);
